import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ReportTypesEnum } from '../enums/reportTypes';
import { useMyAttendanceStore } from '../stores/myAttendance';
import { useAttendanceReportStore } from '../stores/attendanceReport';
import { useProjectTaggingStore } from '../stores/projectTagging';
import { useAttendanceManagementStore } from './attendanceManagement';
import { useBreakMonitoringReportStore } from './breakMonitoringReport';

export const useReportStore = defineStore('report', () => {
  const myAttendanceStore = useMyAttendanceStore();
  const attendanceReportStore = useAttendanceReportStore();
  const projectTaggingStore = useProjectTaggingStore();
  const attendanceManagement = useAttendanceManagementStore();
  const breakMonitoringReport = useBreakMonitoringReportStore();
  const infoToastObj = ref({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  const infoToastActive = ref(1);
  const toggleInfoToast = () => {
    infoToastObj.value[infoToastActive.value] = true;
    infoToastActive.value++;
    if (infoToastActive.value > 5) {
      infoToastActive.value = 1;
    }
  };
  const successToastObj = ref({
    1: { isOpen: false, fileName: '', reportType: null, destination: '' },
    2: { isOpen: false, fileName: '', reportType: null, destination: '' },
    3: { isOpen: false, fileName: '', reportType: null, destination: '' },
    4: { isOpen: false, fileName: '', reportType: null, destination: '' },
    5: { isOpen: false, fileName: '', reportType: null, destination: '' },
  });
  const successToastActive = ref(1);
  const toggleSuccessToast = (data) => {
    if (successToastActive.value > 1) {
      const prevSuccessToast = successToastActive.value - 1;
      successToastObj.value[prevSuccessToast].isOpen = false;
    }
    successToastObj.value[successToastActive.value].isOpen = true;
    successToastObj.value[successToastActive.value].fileName = data.ReportName;
    successToastObj.value[successToastActive.value].reportType =
      data.ReportType;
    successToastObj.value[successToastActive.value].destination =
      fileDestination(data.ReportType);
    successToastActive.value++;
    if (successToastActive.value > 5) {
      successToastActive.value = 1;
    }
    loadReportList(data.ReportType);
  };
  const loadReportList = async (reportType) => {
    const defaultParams = {
      PageNumber: 1,
      RowsPerPage: 10,
    };
    switch (reportType) {
      case ReportTypesEnum.myAttendance:
        await myAttendanceStore.getExportedAttendanceLogs(defaultParams);
        break;
      case ReportTypesEnum.attendanceReport:
        await attendanceReportStore.getExportedAttendanceReport(defaultParams);
        break;
      case ReportTypesEnum.projectTagging:
        await projectTaggingStore.getExportedProjectTagging(defaultParams);
        break;
      case ReportTypesEnum.attendanceManagement:
        await attendanceManagement.getExportedAttendanceManagement(
          defaultParams,
        );
        break;
      case ReportTypesEnum.breakLogs:
        await breakMonitoringReport.getExportedBreakLogsReport(defaultParams);
        break;
      case ReportTypesEnum.breakMonitoringReport:
        await breakMonitoringReport.getExportedBreakMonitoringLogsReport(
          defaultParams,
        );
        break;
      default:
        break;
    }
  };
  const fileDestination = (reportType) => {
    switch (reportType) {
      case ReportTypesEnum.myAttendance:
        return 'My Attendance > Exported Logs';
      case ReportTypesEnum.attendanceReport:
        return 'Attendance Report > Exported Files';
      case ReportTypesEnum.projectTagging:
        return 'Project Tagging > Exported Files';
      case ReportTypesEnum.attendanceManagement:
        return 'Attendance Manager > Exported Files';
      case ReportTypesEnum.breakLogs:
        return 'Break Monitoring Report > Exported Files';
      case ReportTypesEnum.breakMonitoringReport:
        return 'Break Monitoring Report > Exported Reports';
      default:
        break;
    }
  };
  const snackbarObj = ref({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  const snackbarActive = ref(1);
  const toggleSnackbar = () => {
    snackbarObj.value[snackbarActive.value] = true;
    snackbarActive.value++;
    if (snackbarActive.value > 5) {
      snackbarActive.value = 1;
    }
  };

  return {
    infoToastObj,
    infoToastActive,
    toggleInfoToast,
    successToastObj,
    successToastActive,
    toggleSuccessToast,
    snackbarObj,
    snackbarActive,
    toggleSnackbar,
  };
});
